module.exports = __webpack_public_path__ + "static/img/6.2.5.664d9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/6.2.5.png
// module id = BMQj
// module chunks = 0